import { is, object, array, string, number, nullable, enums, optional } from 'superstruct';

const StatusEnum = enums([
  'ORDER_VALIDATION_SUCCESS',
  'ORDER_VALIDATION_ERROR',
  'ORDER_CONFIRMATION_SUCCESS',
  'ORDER_CONFIRMATION_ERROR',
  'ORDER_CANCELLED',
  'ORDER_PAYMENT_ERROR',
  'ORDER_PAYMENT_SUCCESS',
  'ORDER_REFUND_SUCCESS',
  'ORDER_REFUND_ERROR',
  'ORDER_REFUND_CANCELLED',
  'ORDER_POST_SUCCESS',
  'ORDER_POST_ERROR',
]);

const Transactions = array(
  object({
    total: number(),
    status: StatusEnum,
    cart: array(object()),
    message: optional(nullable(string())),
    payment: optional(nullable(object())),
    session: optional(nullable(object())),
    receiptId: optional(nullable(string())),
  }),
);

const validate = (value = null) => {
  // If there are no transactions default to empty array
  if (!value) return [];

  const valid = is(value, Transactions);

  if (!valid) throw new Error('Transactions value does not match Transactions schema');

  return value;
};

export { Transactions, validate };
